import styled from 'styled-components';

const Emphasize = styled.span`
  font-weight: var(--theme-font-weight-emphasize);
`;

export default Emphasize;
